import { FocusContainerValidationResult } from '../observation/validation/focus-container-validation-result.model';
import { InteractionValidationResult } from '../observation/validation/interaction-validation-result.model';
import { ObservationValidationResult } from '../observation/validation/observation-validation-result.model';

export type ValidationResult =
    | ObservationValidationResult
    | FocusContainerValidationResult
    | InteractionValidationResult;

export const FOCUS_CONTAINERS_TRACKING_ID = 9000;

export interface ObservationFormDecorateConnector {
    fdcDecorate: (result: ValidationResult) => void;

    fdcDecorateDelta: (
        result: ValidationResult,
        deltaResult: ValidationResult,
    ) => void;

    fdcUnDecorate: (result: ValidationResult) => void;
}
